document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('button.cart-remove-button, a.button.button--tertiary');
    if (!btn) return; 
    //console.log('🔴 Remove-button click detectado:', btn);

    let productId;
    if (btn.tagName.toLowerCase() === 'button') {
      productId = btn.dataset.productId;
    } else if (btn.tagName.toLowerCase() === 'a') {
      productId = btn.dataset.productId;
    }

    //console.log('🏷  product_id extraído del botón o enlace:', productId);

    if (!productId) {
      console.warn('⚠️ No hay product_id en el botón o enlace, abortando.');
      return;
    }

    const key = 'course_modality';

    // 2) Leemos el array actual del localStorage
    let arr;
    try {
      arr = JSON.parse(localStorage.getItem(key)) || [];
    } catch (err) {
      console.error('❌ Error parseando localStorage:', err);
      arr = [];
    }
    //console.log('📦 Array antes de filtrar:', arr);

    const filtered = arr.filter(item => {
      const value = item.product_id;  
      const keep = value !== productId;
      if (!keep) {
        console.log(`🗑 Eliminando item con product_id="${value}" que coincide con product_id="${productId}"`);
      }
      return keep;
    });

    // Guardar en localStorage
    try {
      localStorage.setItem(key, JSON.stringify(filtered));
      //console.log('💾 localStorage actualizado correctamente.');
    } catch (err) {
      console.error('❌ Error guardando en localStorage:', err);
    }
  });
});
